import QuoteStore from '../modules/quote/store/QuoteStore';
import FlowStore from '../modules/core/store/FlowStore';

class StringsHelper {
  getMessagesByModality(modalityType = null) {
    const { modality } = FlowStore;
    const modalityName = modalityType || modality;

    switch (modalityName) {
      case 'judicial':
      case 'judicial-recursal':
        return require('../strings/judicial.json');
      case 'judicial-execucao':
      case 'Execucao':
        return require('../strings/Execucao.json');
      case 'civel':
      case 'tributaria':
        return require('../strings/Civel.json');
      case 'executante-construtor':
      case 'executante-prestador-de-servicos':
      case 'executante-fornecedor':
        return this.getPerformanceMessages(modalityName);
      case 'licitacao':
        return this.getLicitanteMessages();
      default:
        return {};
    }
  }

  getPerformanceMessages(modality) {
    const common = require('./performance-common.json');
    const messages = require(`../strings/${modality}.json`);
    return Object.assign({}, common, messages);
  }

  getLicitanteMessages() {
    const { Lead } = QuoteStore;
    const common = require('./Licitante.json');

    if (!Lead.simulacao) {
      return common;
    }

    const messages = require('../strings/LicitacaoSimulacao.json');
    return Object.assign({}, common, messages);
  }
}

export default new StringsHelper();
